module.exports = new __parcel__URL__("buildingOffice.0e1161fb.svg").toString();